module.exports = __webpack_public_path__ + "static/media/bed_new_pack_dog_EN_285x285.90402aa5.png";